if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
        this.itemDataLayer = document.querySelector('[data-item-data-layer]');
        this.addToCartEvent = new Event('add_to_cart');
      }
      const priceOneTime = document.querySelector('.product__info-wrapper .price .price__regular .price-item').innerHTML;
      var hasUnit = false;
      setTimeout(function() {
        this.checkboxSub = document.querySelector('#rc-radio1');
        this.checkboxRegular = document.querySelector('#rc-radio2');
        if (checkboxSub) {
          const priceSubscription = document.querySelector('.subscription-radio .price-label').innerHTML;
          console.log('subscription');
          if(checkboxSub.checked) document.querySelector('.product__info-wrapper .price .price__regular .price-item').innerHTML = priceSubscription;
          //unit price
          /*if(document.querySelector('.unit-price.has-unit-price')) {
            const unitPrice = document.querySelector('.unit-price .unit-price-amount[data-unit]').innerHTML;
            const unitReference = document.querySelector('.unit-price .reference-unit-amount[data-unit]').innerHTML;
            hasUnit = true;
          }*/
          checkboxSub.addEventListener('change', () => {
            document.querySelector('.product__info-wrapper .price .price__regular .price-item').innerHTML = priceSubscription;
          });
          checkboxRegular.addEventListener('change', () => {
            document.querySelector('.product__info-wrapper .price .price__regular .price-item').innerHTML = priceOneTime;
          });
        } else console.log('no check');
        // if there is sale
        /*if(window.getComputedStyle(document.querySelector('.price__sale '), null).display !== 'none') {
          console.log('sale');
        }*/
      }, 600);
      this.widgetTranslate();
    }
    widgetTranslate() {
      $(window).on('load', function () {
        if(Shopify.locale == "en") {
          console.log('en');
          setTimeout(function() {
            document.querySelector('.rc-widget .subscription-radio .discount-label').innerHTML = "Subscribe & save 10% on every order";
            document.querySelector('.rc-widget .onetime-radio .discount-label').innerHTML = "One-time purchase";
          }, 600);
        }
     });
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.addToCartEvent.payload = JSON.parse(this.itemDataLayer.innerHTML);
          this.addToCartEvent.payload.quantity = parseInt(formData.get('quantity'));
          document.dispatchEvent(this.addToCartEvent);
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
